import React, { useState, useEffect, useReducer } from "react";

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { showToast } from '../../stores/toastSlice';
import { addProduct, addDate, addPeriod, addFormField } from '../../stores/cartSlice';
import { showModal } from "../../stores/modalSlice";

// Components
import InputComponent from '../../components/InputComponent';
import CategoryComponent from "../../components/CategoryComponent";
import SelectComponent from "../../components/SelectComponent";
import TitleComponent from "../../components/TitleComponent";
import ChoiceButtonsComponent from "../../components/ChoiceButtonsComponent";
import TextAreaComponent from "../../components/TextAreaComponent";
import ButtonFullComponent from "../../components/ButtonFullComponent";
import NumberInput from "../../components/NumberInput";
import InputDateComponent from "../../components/InputDateComponent";
import AdditionalServiceComponent from "../../components/AdditionalServiceComponent";

// Services 
import { authService } from "../../services/auth.service";
import { lineService } from "../../services/line.service";
import { catalogService } from "../../services/catalog.service";
import { addressService } from "../../services/address.service";
import { formatterService } from "../../services/formatters.service";
import { additionalService } from "../../services/additionalServices.service";
import { locationService } from "../../services/location.service";
import store from "../../stores/store";

// Constants
const collectLocalsList = [{ value: 2, text: 'Casa' }, { value: 1, text: 'Apartamento' }];
const periodsList = [{ id: 2, value: '09 às 12h', text: '09 às 12h' }, { id: 3, value: '12h às 18h', text: '12h às 18h' }, { id: 1, value: '09 às 18h', text: '09 às 18h' }];

const formInitialValues = {
    id: 0,
    name: "",
    firstName: "",
    lastName: "",
    email: "",
    obs: "",
    local: "",
    date: "",
    period: "",
    period_text: "",
    zipCode: "",
    address: "",
    number: "",
    complement: "",
    city: "",
    state: "",
    escort: "",// quem acompanhará 
    pointOfReference: "",
    doc: "",
    phone: "",
    anotherEmail: ""
};

const formReducer = (state, event) => {
    if (event.reset) {
        return formInitialValues;
    }

    return {
        ...state,
        [event.name]: event.value,
    };
};

const cartFormInitialValues = {
    product: "",
    quantity: 0,
    productValue: 0,
    additionalService: [],
    obs: ""
};

const cartFormReducer = (state, event) => {
    if (event.reset) {
        return cartFormInitialValues;
    }

    return {
        ...state,
        [event.name]: event.value,
    };
};

function CreateOrderComponent(props) {
    const dispatch = useDispatch();

    const paymentStore = useSelector((state) => state.payment);
    const cart = useSelector((state) => state.cart);

    const [formData, setFormData] = useReducer(formReducer, {});
    const [cartFormData, setCartFormData] = useReducer(cartFormReducer, {});

    const [email, setEmail] = useState(undefined);
    const [additionalServices, setAdditionalServices] = useState([]);
    const [collectLocals] = useState(collectLocalsList);
    const [periods] = useState(periodsList);
    const [lines, setLines] = useState([]);
    const [selectedLines, setSelectedLines] = useState(0);
    const [catalogs, setCatalogs] = useState([]);
    const [catalogsLoading, setCatalogsLoading] = useState(false);
    const [address, setAddress] = useState(null);
    const [availableDates, setAvailableDates] = useState([]);

    const [formDisabledAreas, setFormDisabledAreas] = useState(true);

    const handleShowToast = (message) => {
        dispatch(showToast({ message: message }));
    };

    const handleFormChange = async (event) => {
        const { id, value } = event.target;

        setFormData({
            name: id,
            value: value,
        });

        if (id === "name") {
            setFormData({
                name: "firstName",
                value: value,
            });

            dispatch(addFormField({ id: "firstName", value }));

            if (value && formData.email && formData.phone) {
                // habilita área de categorias se tiver nome e email e conseguir o login
                setFormDisabledAreas(false);
            }
            else {
                setFormDisabledAreas(true);
            }
        }

        if (id === "email") {

            if (!formatterService.validateEmail(value)) {
                dispatch(showToast({ message: "Informe o email válido!", color: 'warning' }));
                setFormDisabledAreas(true);
                return;
            }

            if (value && formData.name && formData.phone) {
                // habilita área de categorias se tiver nome e email
                setFormDisabledAreas(false);
            }
            else {
                setFormDisabledAreas(true);
            }
        }

        if (id === "cell") {

            if (!formatterService.validatePhoneNumber(value)) {
                dispatch(showToast({ message: "Informe um celular válido!", color: 'warning' }));
                setFormDisabledAreas(true);
                return;
            }

            setFormData({
                name: "phone",
                value: value,
            });

            dispatch(addFormField({ id: "phone", value }));


            if (value && formData.name && formData.email) {
                // habilita área de categorias se tiver nome e email
                setFormDisabledAreas(false);
            }
            else {
                setFormDisabledAreas(true);
            }

        }

        if (id === "doc") {

            if (value.length === 14)
                if (formatterService.validateCpf(value)) {
                    setFormData({
                        name: "doc",
                        value: value,
                    });
                }
                else {
                    dispatch(showToast({ message: "CPF Inválido!", color: "warning" }));
                }
        }


        // Update global form state
        dispatch(addFormField({ id, value }));

    };

    const handleLogin = async (name, email) => {
        try {
            await authService.startSession(name, email);

            setLines(await lineService.fetchLines());
            setAdditionalServices(await additionalService.fetchAdditionalService());

        } catch (error) {
            handleShowToast(error.message);
        }
    };


    const handleCartChange = async (event) => {
        const { id, value } = event.target;
        setCartFormData({
            name: id,
            value: value,
        });

        if (id === "product" && !cartFormData.quantity) {
            // Define quantidade para 1
            setCartFormData({
                name: "quantity",
                value: "1",
            });
        }

        if (id === "date") {
            dispatch(addDate({ date: value }));
        }
        if (id === "period") {
            dispatch(addPeriod({ period: value }));
        }
    };

    const handleAddToCart = async () => {

        try {

            if (!cartFormData.product || cartFormData.product === 0) {
                handleShowToast("Informe pelo menos um produto!");
                return;
            }

            if (!cartFormData.quantity || cartFormData.quantity === 0) {
                handleShowToast("Informe a quantidade do produto!");
                return;
            }

            const productToAdd = catalogs.find(x => Number(x.value) === Number(cartFormData.product));
            if (!productToAdd) {
                handleShowToast("Produto não encontrado no catálogo!");
                return;
            }

            let icon_definition = "outros";

            if (selectedLines) {
                const categories = await lineService.fetchCategoriesConfig();

                const line = selectedLines.flatMap(lineId =>
                    categories.find(category => category.references_ids.includes(lineId))
                );

                if (line) {
                    icon_definition = line[0].icon_definition;
                }
            }

            const product = {
                id: productToAdd.value,
                name: productToAdd.text,
                quantity: cartFormData.quantity,
                icon_definition: icon_definition
            };

            dispatch(addProduct(product));

            setCartFormData({
                reset: true
            });

            handleShowToast("Produto adicionado ao carrinho!");

        } catch (error) {
            console.error(error);
            dispatch(showToast({ message: "Não foi possível adicionar ao carrinho", color: "danger" }));
        }

    };

    const defineAddress = async (zipCode) => {
        if (zipCode) {
            try {

                setFormDisabledAreas(true);

                const response = await addressService.fetchAddress(zipCode.replace("-", ""));
                setAddress(response);


                handleFormChange({ target: { id: 'city', value: response?.localidade } });
                handleFormChange({ target: { id: 'state', value: response?.uf } });
                handleFormChange({ target: { id: 'address', value: response?.logradouro } });
                handleFormChange({ target: { id: 'zipCode', value: response?.cep } });
                handleFormChange({ target: { id: 'neigh', value: response?.bairro } });

                if (response) {
                    if (response?.localidade) {
                        try {
                            var distance = await locationService.fetchDistanceByCity(response?.localidade);
                            if (distance > process.env.REACT_APP_DISTANCE_LIMIT) {
                                let title = "Aviso sobre a distância";
                                let message = `Para distâncias maiores que ${process.env.REACT_APP_DISTANCE_LIMIT} Km, é necessário entrar em contato através do botão abaixo.`;

                                dispatch(showModal({ show: true, title, message, showWhats: true }));
                            }
                            else {

                                // Buscar datas disponíveis 
                                var responseDates = await locationService.fetchAvailableDaysByCity(response?.localidade);
                                if (responseDates) {
                                    setAvailableDates(responseDates);
                                }
                                else {
                                    dispatch(showToast({ message: `Nenhuma data de coleta disponível para a cidade ${response?.localidade}` }));
                                }

                                dispatch(showModal({ show: false, title: '', message: "" }));
                            }

                        } catch (error) {
                            console.error(error);
                            dispatch(showModal({ show: false, title: '', message: "" }));
                        }
                    }
                }
                else {
                    dispatch(showToast({ message: "CEP não encontrado!" }));
                }
            } catch (error) {
                console.error(error);
                dispatch(showToast({ message: "CEP não encontrado!" }));
            }
            finally {
                setFormDisabledAreas(false);
            }

        }
    };

    const handleSelectedLine = async (ids) => {

        if (!formData.name) {
            handleShowToast("Informe o nome");
            return;
        }

        if (!formData.email) {
            handleShowToast("Informe o e-mail");
            return;
        }

        try {
            setCatalogsLoading(true);
            setSelectedLines(ids);
            var response = await catalogService.fetchCatalogs(ids);
            if (response) {
                var items = response.map((item) => {
                    return { value: item.catalog_id, text: formatterService.capitalize(item.catalog_name.toUpperCase()) }
                });

                setCatalogs(items);

                handleFormChange({
                    target: {
                        id: "product",
                        value: "",
                    }
                });
            }
        } finally { setCatalogsLoading(false); }
    };


    const handlePeriod = (event) => {
        const { id, value } = event.target;

        var period = periods.find(x => x.value === value);
        if (period) {
            handleFormChange({ target: { id: id, value: period.id } });
            handleFormChange({ target: { id: "period_text", value: value } });
        }
    };

    useEffect(() => {
        if (formDisabledAreas === false && !store.getState().auth.token) {
            handleLogin(formData.name, formData.email);
        }
    }, [formDisabledAreas, store.getState().auth]);

    useEffect(() => {
        // Zerar formulários se 
        if (cart.form.name === "" && cart.form.email === "") {
            setFormData({
                reset: true,
            });
            setCartFormData({
                reset: true,
            });
            setAddress(null);
        }
    }, [cart]);

    return (
        <form>

            <div className="row">
                <TitleComponent title="Informe nome, e-mail e celular para continuar" />

                <div className="col-md-4 mb-1">
                    <InputComponent
                        id="name"
                        placeholder="Nome"
                        handleInput={handleFormChange}
                        value={formData.name || ""}
                        type="text"
                    />
                </div>
                <div className="col-md-4 mb-1">
                    <InputComponent
                        id="email"
                        placeholder="e-mail"
                        handleInput={handleFormChange}
                        onBlur={(value) => {
                            setEmail(prevEmail => {
                                if (prevEmail !== value) {
                                    store.dispatch({ type: "SET_TOKEN", payload: null });
                                }

                                return value;
                            });
                        }}
                        value={formData.email || ""}
                        type="text"
                    />
                </div>
                <div className="col-md-4 mb-1">
                    <InputComponent
                        id="cell"
                        placeholder="Celular"
                        handleInput={handleFormChange}
                        value={formData.cell || ""}
                        type="phone"
                    />
                </div>
            </div>
            <div className="mt-2">
                <CategoryComponent lines={lines} disabled={formDisabledAreas || paymentStore.payed} handleSelectedLine={async (id) => handleSelectedLine(id)} />
            </div>
            <div className="row mt-3" >
                <div className="col-8">
                    <SelectComponent id="product"
                        label="Qual o produto?"
                        placeholder="Selecione um produto"
                        items={catalogs}
                        value={cartFormData.product || ""}
                        handleInput={handleCartChange}
                        disabled={formDisabledAreas || paymentStore.payed}
                        loading={catalogsLoading} />
                </div>

                <div className="col-4">
                    <NumberInput
                        id="quantity"
                        label="Quantidade"
                        handleInput={handleCartChange}
                        disabled={formDisabledAreas || paymentStore.payed}
                        value={cartFormData.quantity || "0"} />
                </div>
            </div>

            <div className="mt-1">
                <ButtonFullComponent text="Incluir no descarte" id="btnDispose" handleClick={async () => handleAddToCart()} disabled={formDisabledAreas || paymentStore.payed} />
            </div>

            <hr />

            <div className="row mt-3">
                <AdditionalServiceComponent
                    id="additionalServices"
                    label="Selecione os Serviços adicionais"
                    items={additionalServices}
                    disabled={formDisabledAreas || paymentStore.payed}
                />
            </div>

            <div className="row mt-3">
                <TextAreaComponent id="obs" label="Observação" placeholder="Ex: Muito pesado e não desmonta" handleInput={handleFormChange} disabled={formDisabledAreas || paymentStore.payed} />
            </div>

            <hr />

            <div className="row mt-3">

                <TitleComponent title="Endereço da coleta" />

                <div className="row mt-2">
                    <div className="col-sm-4">
                        <InputComponent id="zipCode" label="Qual o CEP?" placeholder="" type="cep" value={formData.zipCode || ""} customClass="card-order-input" defineAddress={async (zipCode) => defineAddress(zipCode)} disabled={formDisabledAreas || paymentStore.payed} />
                    </div>
                    <div className="col-sm">
                        <InputComponent id="address" label="Logradouro" placeholder="" type="text" customClass="card-order-input" value={formData.address || ""} handleInput={handleFormChange} disabled={formDisabledAreas || paymentStore.payed} />
                    </div>

                </div>

                <div className="row mt-3">
                    <div className="col-sm-4">
                        <InputComponent id="number" label="Número" type="number" value={formData.number || ""} customClass="card-order-input" maxLength={7} handleInput={handleFormChange} disabled={formDisabledAreas || paymentStore.payed} />
                    </div>
                    <div className="col-sm">
                        <InputComponent id="complement" label="Complemento" placeholder="" type="text" customClass="card-order-input" value={formData.complement || ""} handleInput={handleFormChange} disabled={formDisabledAreas || paymentStore.payed} />
                    </div>
                    <div className="col-sm">
                        <InputComponent id="neigh" label="Bairro" type="text" customClass="card-order-input" value={formData.neigh || ""} handleInput={handleFormChange} disabled={formDisabledAreas || paymentStore.payed} />
                    </div>



                </div>

                <div className="row mt-3">
                    <div className="col-sm-8">
                        <InputComponent id="city" label="Cidade" placeholder="" type="text" customClass="card-order-input" disabled value={address?.localidade} />
                    </div>
                    <div className="col-sm-4">
                        <InputComponent id="state" label="Estado" placeholder="" type="text" customClass="card-order-input" disabled value={address?.uf} />
                    </div>

                </div>

                <div className="row mt-3">
                    <div className="col-sm">
                        <InputComponent id="responsible" label="Quem acompanhará a coleta?" placeholder="" value={formData.responsible || ""} type="text" customClass="card-order-input" handleInput={handleFormChange} disabled={formDisabledAreas || paymentStore.payed} />
                    </div>
                    <div className="col-sm">
                        <InputComponent id="reference" label="Ponto de Referência" placeholder="" type="text" value={formData.reference || ""} customClass="card-order-input" handleInput={handleFormChange} disabled={formDisabledAreas || paymentStore.payed} />
                    </div>

                </div>
            </div>

            <hr />
            <div className="row mt-3">

                <TitleComponent title="Tipo de local e data da coleta" />

                <div className="col-4 choice-local">
                    <ChoiceButtonsComponent id="local" value={formData.local || 0} label="Qual local será retirado?" width={90} items={collectLocals} handleInput={handleFormChange} disabled={formDisabledAreas || paymentStore.payed} />
                </div>
                <div className="col-3 choice-date">
                    <InputDateComponent id="date" label="Data" searchCity={address?.localidade} availableDates={availableDates} placeholder="dd/mm/aaaa" handleInput={handleCartChange} disabled={formDisabledAreas || paymentStore.payed} />
                </div>
                <div className="col-5 choice-period">
                    <ChoiceButtonsComponent id="period" value={formData.period_text || 0} label="Qual o período?" items={periods} handleInput={handlePeriod} disabled={formDisabledAreas || paymentStore.payed} />
                </div>
            </div>



            <hr />

            <div className="row mt-3">
                <TitleComponent title="Complete seu cadastro" />

                <div className="col-sm-4">

                    <InputComponent
                        id="firstName"
                        label="Nome"
                        disabled={true}
                        value={formData.name || ""}
                        type="text"
                        customClass="card-order-input"
                    />
                </div>

                <div className="col-sm-4">
                    <InputComponent
                        id="anotherEmail"
                        label="E-mail"
                        disabled={true}
                        value={formData.email || ""}
                        type="email"
                        customClass="card-order-input"
                    />
                </div>

                <div className="col-sm-4">
                    <InputComponent id="phone" label="Celular" value={formData.cell || ""} placeholder="" type="phone" customClass="card-order-input" disabled={true} />
                </div>

                <div className="row mt-3 mb-5">
                    <div className="col-sm-4">
                        <InputComponent id="lastName" label="Sobrenome" value={formData.lastName || ""} placeholder="" type="text" customClass="card-order-input" handleInput={handleFormChange} />
                    </div>
                    <div className="col-sm-4">
                        <InputComponent
                            id="doc"
                            label="CPF"
                            placeholder=""
                            type="cpf"
                            disabled={formDisabledAreas || paymentStore.payed}
                            customClass="card-order-input"
                            handleInput={handleFormChange}
                            value={formData.dpc || ""} />
                    </div>

                </div>

            </div>


        </form>


    );
}

export default CreateOrderComponent;